import styled from 'styled-components';

export const StyledButtonWrapper = styled.button`
  && {
    all: unset;

    &:hover {
      box-shadow: none !important;
    }

    &:not(:disabled) {
      cursor: pointer !important;
    }
  }
`;
